import { showLoadingModal, hideLoadingModal } from '../transitions/show-loading-modal.js'
import { postData } from '../utils/call-ajax.js'
import { _query } from '../utils/query.js'

export function cityStateLookup (zipVal, countryVal, cityId, stateId, callback) {
  if (window.jaStore) return
  // showLoadingModal()
  $.ajax({
    url: '/api/address/lookup-city-state-by-zip',

    // The data to send (will be converted to a query string)
    data: {
      zip: zipVal,
      country: countryVal
    },

    // Whether this is a POST or GET request
    type: 'GET',

    // The type of data we expect back
    dataType: 'json'
  })
    // Code to run if the request succeeds (is done);
    // The response is passed to the function
    .done((json) => {
      // console.log(json.data.suggested_address);
      if (json.status === 1) {
        $(`#${cityId}`).val(json.data.suggested_address.city)
        $(`#${stateId}`).val(json.data.suggested_address.stateId)
		if (cityId === 'cityBilling' && $('#zipBilling').val().trim() === '') {
		  $('#zipBilling').val($('#zip').val().trim());
		}
        // hideLoading()
        if (callback) {
          callback()
        }
      }
    })
    // Code to run if the request fails; the raw request and
    // status codes are passed to the function
    .fail((xhr, status, errorThrown) => {
      // hideLoadingModal()
    })
    // Code to run regardless of success or failure;
    .always((xhr, status) => {
      // hideLoadingModal()
    })
}

export function cityStateFillIn (zipVal, countryVal, cityId, stateId, callback) {
  showLoadingModal()
  postData('/api/address/lookup-city-state-by-zip', {
      zip: zipVal,
      country: countryVal
    },
    response => {
      console.debug(`response: ${response.status}`)
      if (response.status == 1) {
        const cityIdDiv = _query(`${cityId}`)
        if (cityIdDiv !== null) {
          cityIdDiv.value = response.data.suggested_address.city
        }
        const stateIdDiv = _query(`${stateId}`)
        if (stateIdDiv !== null) {
          stateIdDiv.value = response.data.suggested_address.stateId
        }
        if (callback) {
          callback()
        }
        hideLoadingModal()
      } else {
        console.debug(`response.status !== 1: ${response.status}`)
        hideLoadingModal()
      }
    },
    error => {
      console.error(error)
      hideLoadingModal()
    }
  )
}

